<template>
<div v-if="record.Customer != undefined"> 

   <v-container fluid grid-list-xl pt-0>
   <v-layout row wrap>
        

        
            <v-flex xs12 sm4>
            <v-text-field  label="Voornaam"  v-model="record.Customer.FirstName"></v-text-field>
            <v-text-field  label="Achternaam"  v-model="record.Customer.LastName"></v-text-field>
            <v-text-field  label="Adresgegevens"  v-model="record.Customer.Address"></v-text-field>    
            <v-text-field  label="Postcode"  v-model="record.Customer.ZipCode"></v-text-field>
            <v-text-field  label="Gemeente"  v-model="record.Customer.City"></v-text-field>
            </v-flex>

            <v-flex xs12 sm3>
                <h5>Communicatie</h5>
                <v-text-field  label="Email"  v-model="record.Customer.Email"></v-text-field> 
                <v-text-field  label="Mobiel"  v-model="record.Customer.Mobile"></v-text-field> 
                <v-text-field  label="Telefoon"  v-model="record.Customer.Phone"></v-text-field> 
            </v-flex>

            <v-flex xs12 sm3>
                
            </v-flex>
            <!-- detail-->
           

            <v-flex xs12 sm3>

                <v-dialog ref="dialog" persistent v-model="modal" lazy full-width width="290px" :return-value.sync="dateToUse">
                    <v-text-field slot="activator" label="Geboortedatum" v-model="dateToUse" prepend-icon="event" readonly >
                    </v-text-field>
                    <v-date-picker v-model="dateToUse" scrollable @input="dateToUse = formatDateSQL($event)">
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="modal = false">Cancel</v-btn>
                        <v-btn color="primary" @click="$refs.dialog.save(dateToUse)">OK</v-btn>
                    </v-date-picker>
                </v-dialog>

                
                    
                    <v-select  hide-details v-bind:items="genders" item-value="id"  v-model="record.GenderID"  label="Geslacht"  single-line  menu-props="bottom" ></v-select>
                    <v-text-field  label="Paspoort Nr"  v-model="record.Passport"></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm3>
            </v-flex>
    </v-layout>
    </v-container>
</div>
</template>

<script>

import Vue from 'vue';
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';
import StatsCardV3 from "Components/StatsCardV3/StatsCardV3";
import StatsCardEuro from "Components/StatsCardEURO/StatsCardEuro";

export default {
  props: {
      record : Object,
      kindrec : Number,
      isNew : Boolean
  },
   components: {
    StatsCardV3,
    StatsCardEuro
  },
  mounted() {
    this.imgNoPic = Vue.$urlImgNoPic;
    this.isNewRec = false;
  },
   watch: { 
        record: function(newVal, oldVal) { // watch it
          
          this.dateToUse = newVal.Customer.DatBirth;
          if (this.isNew) {this.dateToUse = '1980-01-01';}
          this.isNewRec = this.isNew;
          console.log ("isnew:" + this.isNewRec);
          this.getRemoteData();
        },
        dateToUse : function(newVal, oldVal) { // watch it
          this.record.Customer.DatBirth = newVal;
        },
   },
  data() {
    return {
        genders: [
            { id: 1, text: "Vrouw" },
            { id: 2, text: "Man" }
        ],
        menuBirthDay : '',
        dateToUse : '',
        modal : '',
        basicInfo : '',
        imgNoPic : '',
        isNewRec : false
    }
  },
   methods: {
    getRemoteData() {
      myHttpApi
        const searchRec = {Search: this.record.Customer.CustomerID, Extra: ""}
        myHttpApi.post( 'BOCustomer/GetBasicInfo', searchRec)
        .then(response => {
            this.basicInfo = response.data;
            this.dateToUse =  this.formatDateSQL (this.record.Customer.DatBirth);
            console.log ("dt:" + this.dateToUse);
        })
        .catch(error => {
          console.log(error);
        });
	},
    formatDateSQL(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      const [dayItem, timeItem]  = day.split("T");
      return `${year}-${month}-${dayItem}`;
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");
      const [dayItem, timeItem]  = day.split("T");
      return `${dayItem}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>
